// ------------ import external dependencies ------------
import React, { Suspense, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { QueryClientProvider, QueryClient } from "react-query";

// import { ReactQueryDevtools } from "react-query/devtools";

// ----------- import internal dependencies -----------
import Toaster from "./components/Notifier";

// import route wrappers
import SchoolRoute from "./routes/SchoolRoute";
import AuthRoutes from "./routes/AuthRoutes";

// ----------- import pages with code splitting ----------

const queryClient = new QueryClient();

function App() {
  const [expToken, setExpToken] = useState(false);

  // checkIfTokenExpires();

  React.useEffect(() => {}, []);

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <Suspense fallback={<div>Loading...</div>}>
          <Router>
            <Routes>
              <Route path="/" element={<Navigate to="/school/dashboard" />} />
              {/* {authRoutes.map((route, ind) => (
                <Route
                  key={ind}
                  path={route.path}
                  element={<route.component />}
                />
              ))} */}
              <Route path="/*" element={<AuthRoutes />} />
              <Route path="/school/*" element={<SchoolRoute />} />
            </Routes>

            <Toaster />
          </Router>
        </Suspense>
        {/* <ReactQueryDevtools initialIsOpen={false} position="bottom-right" /> */}
      </QueryClientProvider>
    </>
  );
}

export default App;
